/*eslint no-warning-comments: "error"*/
/*eslint-disable sonarjs/cognitive-complexity*/
/*eslint-disable github/unescaped-html-literal*/
import { target, targets } from "@github/catalyst";
import { controller } from "./controller";

@controller
export default class DataSetValueElement extends HTMLElement {
  options: NodeListOf<HTMLInputElement> | undefined;
  rsMonitorName: string | null | undefined = "";
  valueTobeSet = false;
  isCustomOpen = false;
  @target input: HTMLInputElement | undefined;
  @targets text: HTMLElement[] | undefined;
  connectedCallback(): void {
    setTimeout(() => {
      this.init();
    }, 0);
  }
  init(): void {
    if (this.text) {
      for (const item of this.text) {
        item.innerHTML = `${item.innerHTML.replace(/\n\n/g, `<br/>`)}`;
      }
    }
    this.rsMonitorName = this.input?.getAttribute("data-set-monitor-name");
    this.options = document.querySelectorAll(
      `input[rsMonitor='${this.rsMonitorName}']`
    ) as NodeListOf<HTMLInputElement>;

    if (this.options) {
      for (const option of this.options) {
        this.setValue();
        this._setAttribute();

        option.onchange = () => {
          this._setAttribute();
          // option.dispatchEvent(new Event("change", { bubbles: true }));
        };
      }
    }
    if (this.input) {
      this.input.oninput = (event) => {
        this._inputOnInputHandler(event, this);
      };
    }
  }

  setRsMontor(): void {
    if (this.options) {
      for (const option of this.options) {
        if (this.isCustomOpen) {
          option.removeAttribute("rsmonitor");
        } else {
          if (this.rsMonitorName) {
            option.setAttribute("rsmonitor", this.rsMonitorName);
          }
        }
      }
    }
  }
  setValue(): void {
    if (this.options) {
      const defaultValue = this.input?.getAttribute("data-set-default-value");
      const inputOption = this.input?.getAttribute("data-set-value-to");
      const opnElm: HTMLInputElement = this.querySelector(`[id = '${inputOption}']`) as HTMLInputElement;

      for (const option of this.options) {
        if (
          defaultValue &&
          option.id !== inputOption &&
          option.value.replace(/\n/g, ``) === defaultValue.replace(/\n/g, ``)
        ) {
          this.valueTobeSet = true;
          option.checked = true;
        }
      }
      opnElm.value = this.valueTobeSet
        ? opnElm.value
        : defaultValue === "undefined"
        ? opnElm.value
        : defaultValue || opnElm.value;
      if (!this.valueTobeSet && defaultValue !== "undefined") {
        opnElm.checked = true;
      }
      if (this.input) {
        this.input.value = opnElm.value === "YES" ? "" : opnElm.value;
      }
    }
  }
  _inputOnInputHandler(event: Event, elm: DataSetValueElement): void {
    const dataSetValueTo: string = (event.target as HTMLInputElement).getAttribute("data-set-value-to") || "";
    if (dataSetValueTo && this.options) {
      setTimeout(() => {
        this.setRsMontor();
      });
      const ev = event.target as HTMLInputElement;
      const value = this.input?.getAttribute("data-set-value");
      (elm.querySelector(`[id = '${dataSetValueTo}']`) as HTMLInputElement).value =
        ev.value.trim() === "" ? (value ? value : "") : ev.value;
    }
  }

  _setAttribute(): void {
    if (this.options) {
      this.isCustomOpen = false;
      const inputOption = this.input?.getAttribute("data-set-value-to");
      //let isDefaultValueSet = false;
      for (const option of this.options) {
        if (this.input) {
          if (option.checked) {
            if (option.id === inputOption) {
              this.isCustomOpen = true;

              this.input.parentElement?.classList.add("showCustom");
              if (this.rsMonitorName) {
                this.input.setAttribute("rsmonitor", this.rsMonitorName);
              }
            } else {
              this.input.parentElement?.classList.remove("showCustom");
              this.isCustomOpen = false;
              this.input.removeAttribute("rsmonitor");
            }
          } else {
            //this.isCustomOpen = false;
            //this.input.parentElement?.classList.remove("showCustom");
          }
        }
      }

      setTimeout(() => {
        this.setRsMontor();
      });
    }
  }
}

declare global {
  interface Window {
    DataSetValueElement: typeof DataSetValueElement;
  }
  interface HTMLElementTagNameMap {
    "data-set-value": DataSetValueElement;
  }
}

if (!window.customElements.get("data-set-value")) {
  window.DataSetValueElement = DataSetValueElement;
  window.customElements.define("data-set-value", DataSetValueElement);
}
